import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { RxStomp } from '@stomp/rx-stomp';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class WebSocketService {
  private rxStomp: RxStomp = new RxStomp();

  constructor() {
    this.initialize();
  }

  private initialize() {
    this.rxStomp.configure({
      brokerURL: environment.urlWS,
      // reconnectDelay: 1000,
      debug: (msg: string | any): void => {
        if (!environment.production) {
          // console.log(new Date(), msg);
        }
      },
    });

    this.rxStomp.activate();
  }

  subscribe(queue: any, callback: any) {
    return this.rxStomp
      .watch(queue)
      .pipe(
        tap((msg) => {
          // console.log(msg.body);
        })
      )
      .subscribe(callback);
  }
}
